<template>
  <div>
    <back-button
      justify="start"
      class="mb-3"
    />

    <v-container>
      <direct-payment-edit-amount v-if="isConfirmingPayment" />

      <captcha-container
        v-if="isPlaceOrderRecaptchaSplitEnabled"
        v-slot="{ generateCaptchaToken }"
        action="submit_payment"
      >
        <ingo-pay-container
          @submit-payment="submitPayment(generateCaptchaToken)"
          @is-reviewing-payment="isConfirmingPayment = $event"
        />
      </captcha-container>

      <ingo-pay-container
        v-else
        @submit-payment="submitPayment"
        @is-reviewing-payment="isConfirmingPayment = $event"
      />
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as getTypes from '@/store/get-types'
import * as actionTypes from '@/store/action-types'
import BackButton from '@/components/footer/BackButton'
import IngoPayContainer from '@/components/direct-payments/IngoPayContainer'
import CaptchaContainer from '@/components/shared/captcha/CaptchaContainer'
import { RL_PLACE_ORDER_RECAPTCHA } from '@/plugins/split/ActiveSplits'
import DirectPaymentEditAmount from '@/components/direct-payments/DirectPaymentEditAmount'

const { CartItem } = require('@/store/classes')

export default {
  name: 'DirectPaymentContainer',
  components: {
    BackButton,
    CaptchaContainer,
    DirectPaymentEditAmount,
    IngoPayContainer
  },
  data: () => ({
    isConfirmingPayment: false
  }),
  computed: {
    ...mapGetters({
      amount: getTypes.GET_DIRECT_PAYMENT_AMOUNT,
      cartExternalRefId: getTypes.GET_CART_EXTERNAL_REF_ID,
      etid: getTypes.GET_REWARD_CUSTOMIZATION_ETID,
      sessionId: getTypes.GET_DIRECT_PAYMENT_SESSION_ID,
      utid: getTypes.GET_DIRECT_PAYMENT_UTID,
      // Disbursement Links are all locked for the time being.  This is subject to change in the future,
      // but in the meantime, we'll use the recipient details from the stored value.
      // Any change would require designs to allow entering the recipient information.
      checkoutEmail: getTypes.GET_REWARD_LINK_EMAIL,
      checkoutFirstName: getTypes.GET_REWARD_LINK_FIRST_NAME,
      checkoutLastName: getTypes.GET_REWARD_LINK_LAST_NAME
    }),
    isPlaceOrderRecaptchaSplitEnabled () {
      return this.$isSplitEnabled(RL_PLACE_ORDER_RECAPTCHA)
    }
  },
  methods: {
    ...mapActions({
      placeOrder: actionTypes.PLACE_ORDER
    }),
    async submitPayment (generateCaptchaToken) {
      const lineItem = new CartItem.Builder()
        .utid(this.utid)
        .amount(this.amount)
        .build()
        .toLineItem()
      lineItem.etid = this.etid
      lineItem.recipient = {
        firstName: this.checkoutFirstName,
        lastName: this.checkoutLastName,
        email: this.checkoutEmail
      }
      lineItem.supplierFields = {
        sessionId: this.sessionId
      }
      await this.placeOrder({
        externalReferenceId: this.cartExternalRefId,
        lineItems: [lineItem],
        generateCaptchaToken
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
